import { detectCase } from "../../utils/detectCase";
import { ResultColumn } from "../SearchContents/SearchResults";
import { RowData } from "./BodyRow";
import {
    SearchResultsHeader,
    SearchResultsItem,
} from "../SearchContents/SearchContents";

export const composeTableHeaders = (
    columns: ResultColumn[]
): SearchResultsHeader[] => {
    return columns
        .filter(
            (columnDef) =>
                typeof columnDef.label !== "undefined" &&
                typeof columnDef.cellDisplay !== "undefined"
        )
        .map((columnDef) => {
            const { cellDisplay, columnKey, label, cellClassName } = columnDef;
            return {
                label,
                columnKey,
                cellDisplay,
                cellClassName,
            } as SearchResultsHeader;
        });
};

export const composeTableData = (
    headers: SearchResultsHeader[],
    items: SearchResultsItem[]
): RowData[] =>
    items.map((item) => {
        const { url, clickTrackingUrl } = item;
        const { determinationdateOfDecision, fileSize, fileType, isExternalLink, isDfp } =
            item;
        return headers.length
            ? headers.map((header) => {
                  const { cellDisplay, columnKey, label } = header;
                  if (
                      detectCase(columnKey) !== "camelcase" &&
                      detectCase(columnKey) !== "lowercase"
                  ) {
                      throw new Error(
                          `columnKey value "${columnKey}" must use camelCase`
                      );
                  }
                  const clusterUrl = item.clusterUrl;
                  const isClusterColumnWithUrl =
                      columnKey === "cluster" &&
                      typeof clusterUrl === "string" &&
                      clusterUrl.trim() !== "";
                  const cellUrl = isClusterColumnWithUrl
                      ? `./?a=${clusterUrl.trim()}`
                      : url ?? "";
                  const cellDisplayForCell = isClusterColumnWithUrl
                      ? "textLink"
                      : cellDisplay;

                  const cellProps = {
                      label: label,
                      header: columnKey,
                      data: item[columnKey] || "",
                      cellDisplay: cellDisplayForCell,
                      url: cellUrl,
                      determinationdateOfDecision:
                          determinationdateOfDecision ?? "",
                      fileSize: fileSize ?? "",
                      fileType: fileType ?? "",
                      isExternalLink: isExternalLink ?? "",
                      isDfp: isDfp ?? "",
                      clickTrackingUrl: clickTrackingUrl ?? "",
                  };
                  return cellProps;
              })
            : [];
    });
